// Import jQuery and make it globally available
window.jQuery = window.$ = require('jquery');

// Import Bootstrap components
import Tooltip from 'bootstrap/js/dist/tooltip';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Alert from 'bootstrap/js/dist/alert';
import Tab from 'bootstrap/js/dist/tab';

// Import custom components
require("./components/data-chart-load");
// Initialize Bootstrap components and custom functionality
$(function () {
    // Initialize tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-tooltip]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl, {
            boundary: 'window'
        });
    });

    // Initialize tabs if present
    const tabElList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'));
    tabElList.map(function (tabEl) {
        return new Tab(tabEl);
    });

    // Deploy status observer for dynamic content loading
    const deployStatusCallback = (entries) => {
        entries.forEach((entry) => {
            const self = $(entry.target);
            if (entry.isIntersecting) {
                let interval = self.data('interval') || 30;

                const load = function () {
                    $.getJSON("/" + self.data('deploy-status') + "/status.json", function (res) {
                        if (res.success) {
                            self.html(res.content);
                        }
                    });
                };

                self.data("reload-timer", setInterval(load, interval * 1000));
                load();
            } else {
                if (self.data("reload-timer")) {
                    clearInterval(self.data("reload-timer"));
                    self.data("reload-timer", null);
                }
            }
        });
    };

    // Initialize IntersectionObserver for deploy status elements
    const observer = new IntersectionObserver(deployStatusCallback);
    $('[data-deploy-status]').each(function () {
        observer.observe(this);
    });
});
